/*
 *  ------------------------------
 *   GENERATED CODE - DO NOT EDIT
 *  ------------------------------
 *
 * Generated from:
 *   - src/domain.model
 *   - codegen/templates/domain.ts.mustache
 *   - codegen/gen_domain.ts.ts
 *
 */

import DomainModel from "./domain-model";
import { Vector3 } from "./math/vector3";

export class DoorObstruction extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("id", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("width", null);
        this.fields.set("height", null);
        this.fields.set("depth", null);
        this.fields.set("hinge", "right");
        this.fields.set("swing", "in");
    }


    get id(): string {
        return this.get("id") as string;
    }
    set id(value: string) {
        this.set("id", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get depth(): number {
        return this.get("depth") as number;
    }
    set depth(value: number) {
        this.set("depth", value);
    }
    get hinge(): "left" | "right" | "double" | "pocket" | "pocket-double" | "bi-fold-left" | "bi-fold-right" | "bi-fold-double" | "bypass" {
        return this.get("hinge") as "left" | "right" | "double" | "pocket" | "pocket-double" | "bi-fold-left" | "bi-fold-right" | "bi-fold-double" | "bypass";
    }
    set hinge(value: "left" | "right" | "double" | "pocket" | "pocket-double" | "bi-fold-left" | "bi-fold-right" | "bi-fold-double" | "bypass") {
        this.set("hinge", value);
    }
    get swing(): "in" | "out" {
        return this.get("swing") as "in" | "out";
    }
    set swing(value: "in" | "out") {
        this.set("swing", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): DoorObstruction {
        const clone = new DoorObstruction(parent ?? this.parent);
        if(deep) {
            clone.id = this.id;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.width = this.width;
            clone.height = this.height;
            clone.depth = this.depth;
            clone.hinge = this.hinge;
            clone.swing = this.swing;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): DoorObstruction
    {
        const result = new DoorObstruction(parent);
        if(!data) {
            return result;
        }

        result.id = data["id"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.width = data["width"] ?? null;
        result.height = data["height"] ?? null;
        result.depth = data["depth"] ?? null;
        result.hinge = data["hinge"] ?? "right";
        result.swing = data["swing"] ?? "in";
        result.commit();
        return result;
    }

}

export class ClosetUnit extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("id", null);
        this.fields.set("width", null);
        this.fields.set("height", null);
        this.fields.set("depth", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("thickness", 0.75);
        this.fields.set("leftPanel", null);
        this.fields.set("rightPanel", null);
        this.fields.set("cornerType", "none");
        this.fields.set("content", Section.fromJSON({}));
    }


    get id(): string {
        return this.get("id") as string;
    }
    set id(value: string) {
        this.set("id", value);
    }
    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get depth(): number {
        return this.get("depth") as number;
    }
    set depth(value: number) {
        this.set("depth", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get thickness(): 1 | 0.75 | 0.5 {
        return this.get("thickness") as 1 | 0.75 | 0.5;
    }
    set thickness(value: 1 | 0.75 | 0.5) {
        this.set("thickness", value);
    }
    get leftPanel(): VerticalPanel {
        return this.get("leftPanel") as VerticalPanel;
    }
    set leftPanel(value: VerticalPanel) {
        this.set("leftPanel", value);
    }
    get rightPanel(): VerticalPanel {
        return this.get("rightPanel") as VerticalPanel;
    }
    set rightPanel(value: VerticalPanel) {
        this.set("rightPanel", value);
    }
    get cornerType(): "none" | "L" | "pie" | "rad" {
        return this.get("cornerType") as "none" | "L" | "pie" | "rad";
    }
    set cornerType(value: "none" | "L" | "pie" | "rad") {
        this.set("cornerType", value);
    }
    get content(): Section {
        return this.get("content") as Section;
    }
    set content(value: Section) {
        this.set("content", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): ClosetUnit {
        const clone = new ClosetUnit(parent ?? this.parent);
        if(deep) {
            clone.id = this.id;
            clone.width = this.width;
            clone.height = this.height;
            clone.depth = this.depth;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.thickness = this.thickness;
            clone.leftPanel = this.leftPanel?.clone(true, clone);
            clone.rightPanel = this.rightPanel?.clone(true, clone);
            clone.cornerType = this.cornerType;
            clone.content = this.content?.clone(true, clone);
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): ClosetUnit
    {
        const result = new ClosetUnit(parent);
        if(!data) {
            return result;
        }

        result.id = data["id"] ?? null;
        result.width = data["width"] ?? null;
        result.height = data["height"] ?? null;
        result.depth = data["depth"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.thickness = data["thickness"] ?? 0.75;
        result.leftPanel = data["leftPanel"]
            ? VerticalPanel.fromJSON(data["leftPanel"], result)
            : null;
        result.rightPanel = data["rightPanel"]
            ? VerticalPanel.fromJSON(data["rightPanel"], result)
            : null;
        result.cornerType = data["cornerType"] ?? "none";
        result.content = data["content"]
            ? Section.fromJSON(data["content"], result)
            : Section.fromJSON({});
        result.commit();
        return result;
    }

}

export class Cubby extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("width", null);
        this.fields.set("height", null);
        this.fields.set("depth", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("opacity", 1);
        this.fields.set("diagonal", false);
        this.fields.set("thickness", 0.5);
        this.fields.set("countY", null);
        this.fields.set("countX", null);
        this.fields.set("faceMaterial", Material.fromJSON({}));
        this.fields.set("boxMaterial", Material.fromJSON({}));
        this.fields.set("layerId", null);
    }


    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get depth(): number {
        return this.get("depth") as number;
    }
    set depth(value: number) {
        this.set("depth", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get opacity(): number {
        return this.get("opacity") as number;
    }
    set opacity(value: number) {
        this.set("opacity", value);
    }
    get diagonal(): boolean {
        return this.get("diagonal") as boolean;
    }
    set diagonal(value: boolean) {
        this.set("diagonal", value);
    }
    get thickness(): 1 | 0.75 | 0.5 {
        return this.get("thickness") as 1 | 0.75 | 0.5;
    }
    set thickness(value: 1 | 0.75 | 0.5) {
        this.set("thickness", value);
    }
    get countY(): number {
        return this.get("countY") as number;
    }
    set countY(value: number) {
        this.set("countY", value);
    }
    get countX(): number {
        return this.get("countX") as number;
    }
    set countX(value: number) {
        this.set("countX", value);
    }
    get faceMaterial(): Material {
        return this.get("faceMaterial") as Material;
    }
    set faceMaterial(value: Material) {
        this.set("faceMaterial", value);
    }
    get boxMaterial(): Material {
        return this.get("boxMaterial") as Material;
    }
    set boxMaterial(value: Material) {
        this.set("boxMaterial", value);
    }
    get layerId(): string {
        return this.get("layerId") as string;
    }
    set layerId(value: string) {
        this.set("layerId", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Cubby {
        const clone = new Cubby(parent ?? this.parent);
        if(deep) {
            clone.width = this.width;
            clone.height = this.height;
            clone.depth = this.depth;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.opacity = this.opacity;
            clone.diagonal = this.diagonal;
            clone.thickness = this.thickness;
            clone.countY = this.countY;
            clone.countX = this.countX;
            clone.faceMaterial = this.faceMaterial?.clone(true, clone);
            clone.boxMaterial = this.boxMaterial?.clone(true, clone);
            clone.layerId = this.layerId;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Cubby
    {
        const result = new Cubby(parent);
        if(!data) {
            return result;
        }

        result.width = data["width"] ?? null;
        result.height = data["height"] ?? null;
        result.depth = data["depth"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.opacity = data["opacity"] ?? 1;
        result.diagonal = data["diagonal"] ?? false;
        result.thickness = data["thickness"] ?? 0.5;
        result.countY = data["countY"] ?? null;
        result.countX = data["countX"] ?? null;
        result.faceMaterial = data["faceMaterial"]
            ? Material.fromJSON(data["faceMaterial"], result)
            : Material.fromJSON({});
        result.boxMaterial = data["boxMaterial"]
            ? Material.fromJSON(data["boxMaterial"], result)
            : Material.fromJSON({});
        result.layerId = data["layerId"] ?? null;
        result.commit();
        return result;
    }

}

export class Door extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("width", null);
        this.fields.set("height", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("hinge", "left");
        this.fields.set("open", 0);
        this.fields.set("opacity", 1);
        this.fields.set("frame", null);
        this.fields.set("panel", Panel.fromJSON({}));
        this.fields.set("handles", []);
        this.fields.set("type", "door");
        this.fields.set("layerId", null);
    }


    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get hinge(): "bottom" | "top" | "left" | "right" | "double" | "bi-fold-left" | "bi-fold-right" | "bi-fold-double" {
        return this.get("hinge") as "bottom" | "top" | "left" | "right" | "double" | "bi-fold-left" | "bi-fold-right" | "bi-fold-double";
    }
    set hinge(value: "bottom" | "top" | "left" | "right" | "double" | "bi-fold-left" | "bi-fold-right" | "bi-fold-double") {
        this.set("hinge", value);
    }
    get open(): number {
        return this.get("open") as number;
    }
    set open(value: number) {
        this.set("open", value);
    }
    get opacity(): number {
        return this.get("opacity") as number;
    }
    set opacity(value: number) {
        this.set("opacity", value);
    }
    get frame(): Frame {
        return this.get("frame") as Frame;
    }
    set frame(value: Frame) {
        this.set("frame", value);
    }
    get panel(): Panel {
        return this.get("panel") as Panel;
    }
    set panel(value: Panel) {
        this.set("panel", value);
    }
    get handles(): Handle[] {
        return this.get("handles") as Handle[];
    }
    set handles(value: Handle[]) {
        this.set("handles", value);
    }
    get type(): "hamper" | "door" {
        return this.get("type") as "hamper" | "door";
    }
    set type(value: "hamper" | "door") {
        this.set("type", value);
    }
    get layerId(): string {
        return this.get("layerId") as string;
    }
    set layerId(value: string) {
        this.set("layerId", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Door {
        const clone = new Door(parent ?? this.parent);
        if(deep) {
            clone.width = this.width;
            clone.height = this.height;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.hinge = this.hinge;
            clone.open = this.open;
            clone.opacity = this.opacity;
            clone.frame = this.frame?.clone(true, clone);
            clone.panel = this.panel?.clone(true, clone);
            clone.handles = this.handles.map(
                item => item.clone(true, clone));
            clone.type = this.type;
            clone.layerId = this.layerId;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Door
    {
        const result = new Door(parent);
        if(!data) {
            return result;
        }

        result.width = data["width"] ?? null;
        result.height = data["height"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.hinge = data["hinge"] ?? "left";
        result.open = data["open"] ?? 0;
        result.opacity = data["opacity"] ?? 1;
        result.frame = data["frame"]
            ? Frame.fromJSON(data["frame"], result)
            : null;
        result.panel = data["panel"]
            ? Panel.fromJSON(data["panel"], result)
            : Panel.fromJSON({});
        result.handles = data["handles"]
            ? data["handles"].map(
                (item: any) => Handle.fromJSON(item, result))
            : [];
        result.type = data["type"] ?? "door";
        result.layerId = data["layerId"] ?? null;
        result.commit();
        return result;
    }

}

export class Drawer extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("width", null);
        this.fields.set("height", null);
        this.fields.set("depth", null);
        this.fields.set("nominalHeight", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("opacity", 1);
        this.fields.set("open", 0);
        this.fields.set("scoop", null);
        this.fields.set("frame", null);
        this.fields.set("panel", null);
        this.fields.set("overlay", null);
        this.fields.set("handles", []);
        this.fields.set("box", DrawerBox.fromJSON({}));
        this.fields.set("type", null);
        this.fields.set("layerId", null);
    }


    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get depth(): number {
        return this.get("depth") as number;
    }
    set depth(value: number) {
        this.set("depth", value);
    }
    get nominalHeight(): string {
        return this.get("nominalHeight") as string;
    }
    set nominalHeight(value: string) {
        this.set("nominalHeight", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get opacity(): number {
        return this.get("opacity") as number;
    }
    set opacity(value: number) {
        this.set("opacity", value);
    }
    get open(): number {
        return this.get("open") as number;
    }
    set open(value: number) {
        this.set("open", value);
    }
    get scoop(): boolean {
        return this.get("scoop") as boolean;
    }
    set scoop(value: boolean) {
        this.set("scoop", value);
    }
    get frame(): Frame {
        return this.get("frame") as Frame;
    }
    set frame(value: Frame) {
        this.set("frame", value);
    }
    get panel(): Panel {
        return this.get("panel") as Panel;
    }
    set panel(value: Panel) {
        this.set("panel", value);
    }
    get overlay(): number {
        return this.get("overlay") as number;
    }
    set overlay(value: number) {
        this.set("overlay", value);
    }
    get handles(): Handle[] {
        return this.get("handles") as Handle[];
    }
    set handles(value: Handle[]) {
        this.set("handles", value);
    }
    get box(): DrawerBox {
        return this.get("box") as DrawerBox;
    }
    set box(value: DrawerBox) {
        this.set("box", value);
    }
    get type(): string {
        return this.get("type") as string;
    }
    set type(value: string) {
        this.set("type", value);
    }
    get layerId(): string {
        return this.get("layerId") as string;
    }
    set layerId(value: string) {
        this.set("layerId", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Drawer {
        const clone = new Drawer(parent ?? this.parent);
        if(deep) {
            clone.width = this.width;
            clone.height = this.height;
            clone.depth = this.depth;
            clone.nominalHeight = this.nominalHeight;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.opacity = this.opacity;
            clone.open = this.open;
            clone.scoop = this.scoop;
            clone.frame = this.frame?.clone(true, clone);
            clone.panel = this.panel?.clone(true, clone);
            clone.overlay = this.overlay;
            clone.handles = this.handles.map(
                item => item.clone(true, clone));
            clone.box = this.box?.clone(true, clone);
            clone.type = this.type;
            clone.layerId = this.layerId;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Drawer
    {
        const result = new Drawer(parent);
        if(!data) {
            return result;
        }

        result.width = data["width"] ?? null;
        result.height = data["height"] ?? null;
        result.depth = data["depth"] ?? null;
        result.nominalHeight = data["nominalHeight"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.opacity = data["opacity"] ?? 1;
        result.open = data["open"] ?? 0;
        result.scoop = data["scoop"] ?? null;
        result.frame = data["frame"]
            ? Frame.fromJSON(data["frame"], result)
            : null;
        result.panel = data["panel"]
            ? Panel.fromJSON(data["panel"], result)
            : null;
        result.overlay = data["overlay"] ?? null;
        result.handles = data["handles"]
            ? data["handles"].map(
                (item: any) => Handle.fromJSON(item, result))
            : [];
        result.box = data["box"]
            ? DrawerBox.fromJSON(data["box"], result)
            : DrawerBox.fromJSON({});
        result.type = data["type"] ?? null;
        result.layerId = data["layerId"] ?? null;
        result.commit();
        return result;
    }

}

export class DrawerBox extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("width", null);
        this.fields.set("height", null);
        this.fields.set("depth", null);
        this.fields.set("modelAssetId", null);
        this.fields.set("front", null);
        this.fields.set("materials", []);
    }


    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get depth(): number {
        return this.get("depth") as number;
    }
    set depth(value: number) {
        this.set("depth", value);
    }
    get modelAssetId(): string {
        return this.get("modelAssetId") as string;
    }
    set modelAssetId(value: string) {
        this.set("modelAssetId", value);
    }
    get front(): boolean {
        return this.get("front") as boolean;
    }
    set front(value: boolean) {
        this.set("front", value);
    }
    get materials(): Material[] {
        return this.get("materials") as Material[];
    }
    set materials(value: Material[]) {
        this.set("materials", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): DrawerBox {
        const clone = new DrawerBox(parent ?? this.parent);
        if(deep) {
            clone.width = this.width;
            clone.height = this.height;
            clone.depth = this.depth;
            clone.modelAssetId = this.modelAssetId;
            clone.front = this.front;
            clone.materials = this.materials.map(
                item => item.clone(true, clone));
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): DrawerBox
    {
        const result = new DrawerBox(parent);
        if(!data) {
            return result;
        }

        result.width = data["width"] ?? null;
        result.height = data["height"] ?? null;
        result.depth = data["depth"] ?? null;
        result.modelAssetId = data["modelAssetId"] ?? null;
        result.front = data["front"] ?? null;
        result.materials = data["materials"]
            ? data["materials"].map(
                (item: any) => Material.fromJSON(item, result))
            : [];
        result.commit();
        return result;
    }

}

export class Frame extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("style", "frame_original_2.5in");
        this.fields.set("material", Material.fromJSON({}));
    }


    get style(): string {
        return this.get("style") as string;
    }
    set style(value: string) {
        this.set("style", value);
    }
    get material(): Material {
        return this.get("material") as Material;
    }
    set material(value: Material) {
        this.set("material", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Frame {
        const clone = new Frame(parent ?? this.parent);
        if(deep) {
            clone.style = this.style;
            clone.material = this.material?.clone(true, clone);
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Frame
    {
        const result = new Frame(parent);
        if(!data) {
            return result;
        }

        result.style = data["style"] ?? "frame_original_2.5in";
        result.material = data["material"]
            ? Material.fromJSON(data["material"], result)
            : Material.fromJSON({});
        result.commit();
        return result;
    }

}

export class GenericAsset extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("width", null);
        this.fields.set("height", null);
        this.fields.set("depth", null);
        this.fields.set("availableWidths", []);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("assetId", null);
        this.fields.set("filename", null);
        this.fields.set("opacity", 1);
        this.fields.set("materials", []);
        this.fields.set("type", null);
        this.fields.set("layerId", null);
    }


    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get depth(): number {
        return this.get("depth") as number;
    }
    set depth(value: number) {
        this.set("depth", value);
    }
    get availableWidths(): number[] {
        return this.get("availableWidths") as number[];
    }
    set availableWidths(value: number[]) {
        this.set("availableWidths", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get assetId(): string {
        return this.get("assetId") as string;
    }
    set assetId(value: string) {
        this.set("assetId", value);
    }
    get filename(): string {
        return this.get("filename") as string;
    }
    set filename(value: string) {
        this.set("filename", value);
    }
    get opacity(): number {
        return this.get("opacity") as number;
    }
    set opacity(value: number) {
        this.set("opacity", value);
    }
    get materials(): Material[] {
        return this.get("materials") as Material[];
    }
    set materials(value: Material[]) {
        this.set("materials", value);
    }
    get type(): string {
        return this.get("type") as string;
    }
    set type(value: string) {
        this.set("type", value);
    }
    get layerId(): string {
        return this.get("layerId") as string;
    }
    set layerId(value: string) {
        this.set("layerId", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): GenericAsset {
        const clone = new GenericAsset(parent ?? this.parent);
        if(deep) {
            clone.width = this.width;
            clone.height = this.height;
            clone.depth = this.depth;
            clone.availableWidths = this.availableWidths == null ? null : Array.from(this.availableWidths);
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.assetId = this.assetId;
            clone.filename = this.filename;
            clone.opacity = this.opacity;
            clone.materials = this.materials.map(
                item => item.clone(true, clone));
            clone.type = this.type;
            clone.layerId = this.layerId;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): GenericAsset
    {
        const result = new GenericAsset(parent);
        if(!data) {
            return result;
        }

        result.width = data["width"] ?? null;
        result.height = data["height"] ?? null;
        result.depth = data["depth"] ?? null;
        result.availableWidths = data["availableWidths"] == null ? null : Array.from(data["availableWidths"]);
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.assetId = data["assetId"] ?? null;
        result.filename = data["filename"] ?? null;
        result.opacity = data["opacity"] ?? 1;
        result.materials = data["materials"]
            ? data["materials"].map(
                (item: any) => Material.fromJSON(item, result))
            : [];
        result.type = data["type"] ?? null;
        result.layerId = data["layerId"] ?? null;
        result.commit();
        return result;
    }

}

export class Group extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("assets", []);
        this.fields.set("beds", []);
        this.fields.set("closetUnits", []);
        this.fields.set("cubbies", []);
        this.fields.set("doors", []);
        this.fields.set("drawers", []);
        this.fields.set("hookRacks", []);
        this.fields.set("panels", []);
        this.fields.set("parametricParts", []);
        this.fields.set("sections", []);
        this.fields.set("slantedShelves", []);
    }


    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get assets(): GenericAsset[] {
        return this.get("assets") as GenericAsset[];
    }
    set assets(value: GenericAsset[]) {
        this.set("assets", value);
    }
    get beds(): Murphybed[] {
        return this.get("beds") as Murphybed[];
    }
    set beds(value: Murphybed[]) {
        this.set("beds", value);
    }
    get closetUnits(): ClosetUnit[] {
        return this.get("closetUnits") as ClosetUnit[];
    }
    set closetUnits(value: ClosetUnit[]) {
        this.set("closetUnits", value);
    }
    get cubbies(): Cubby[] {
        return this.get("cubbies") as Cubby[];
    }
    set cubbies(value: Cubby[]) {
        this.set("cubbies", value);
    }
    get doors(): Door[] {
        return this.get("doors") as Door[];
    }
    set doors(value: Door[]) {
        this.set("doors", value);
    }
    get drawers(): Drawer[] {
        return this.get("drawers") as Drawer[];
    }
    set drawers(value: Drawer[]) {
        this.set("drawers", value);
    }
    get hookRacks(): HookRack[] {
        return this.get("hookRacks") as HookRack[];
    }
    set hookRacks(value: HookRack[]) {
        this.set("hookRacks", value);
    }
    get panels(): VerticalPanel[] {
        return this.get("panels") as VerticalPanel[];
    }
    set panels(value: VerticalPanel[]) {
        this.set("panels", value);
    }
    get parametricParts(): ParametricPart[] {
        return this.get("parametricParts") as ParametricPart[];
    }
    set parametricParts(value: ParametricPart[]) {
        this.set("parametricParts", value);
    }
    get sections(): Section[] {
        return this.get("sections") as Section[];
    }
    set sections(value: Section[]) {
        this.set("sections", value);
    }
    get slantedShelves(): SlantedShelf[] {
        return this.get("slantedShelves") as SlantedShelf[];
    }
    set slantedShelves(value: SlantedShelf[]) {
        this.set("slantedShelves", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Group {
        const clone = new Group(parent ?? this.parent);
        if(deep) {
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.assets = this.assets.map(
                item => item.clone(true, clone));
            clone.beds = this.beds.map(
                item => item.clone(true, clone));
            clone.closetUnits = this.closetUnits.map(
                item => item.clone(true, clone));
            clone.cubbies = this.cubbies.map(
                item => item.clone(true, clone));
            clone.doors = this.doors.map(
                item => item.clone(true, clone));
            clone.drawers = this.drawers.map(
                item => item.clone(true, clone));
            clone.hookRacks = this.hookRacks.map(
                item => item.clone(true, clone));
            clone.panels = this.panels.map(
                item => item.clone(true, clone));
            clone.parametricParts = this.parametricParts.map(
                item => item.clone(true, clone));
            clone.sections = this.sections.map(
                item => item.clone(true, clone));
            clone.slantedShelves = this.slantedShelves.map(
                item => item.clone(true, clone));
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Group
    {
        const result = new Group(parent);
        if(!data) {
            return result;
        }

        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.assets = data["assets"]
            ? data["assets"].map(
                (item: any) => GenericAsset.fromJSON(item, result))
            : [];
        result.beds = data["beds"]
            ? data["beds"].map(
                (item: any) => Murphybed.fromJSON(item, result))
            : [];
        result.closetUnits = data["closetUnits"]
            ? data["closetUnits"].map(
                (item: any) => ClosetUnit.fromJSON(item, result))
            : [];
        result.cubbies = data["cubbies"]
            ? data["cubbies"].map(
                (item: any) => Cubby.fromJSON(item, result))
            : [];
        result.doors = data["doors"]
            ? data["doors"].map(
                (item: any) => Door.fromJSON(item, result))
            : [];
        result.drawers = data["drawers"]
            ? data["drawers"].map(
                (item: any) => Drawer.fromJSON(item, result))
            : [];
        result.hookRacks = data["hookRacks"]
            ? data["hookRacks"].map(
                (item: any) => HookRack.fromJSON(item, result))
            : [];
        result.panels = data["panels"]
            ? data["panels"].map(
                (item: any) => VerticalPanel.fromJSON(item, result))
            : [];
        result.parametricParts = data["parametricParts"]
            ? data["parametricParts"].map(
                (item: any) => ParametricPart.fromJSON(item, result))
            : [];
        result.sections = data["sections"]
            ? data["sections"].map(
                (item: any) => Section.fromJSON(item, result))
            : [];
        result.slantedShelves = data["slantedShelves"]
            ? data["slantedShelves"].map(
                (item: any) => SlantedShelf.fromJSON(item, result))
            : [];
        result.commit();
        return result;
    }

}

export class Handle extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("width", null);
        this.fields.set("height", null);
        this.fields.set("assetId", null);
        this.fields.set("isExtrusionPull", null);
        this.fields.set("style", null);
        this.fields.set("opacity", 1);
        this.fields.set("materials", []);
        this.fields.set("side", null);
    }


    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get assetId(): string {
        return this.get("assetId") as string;
    }
    set assetId(value: string) {
        this.set("assetId", value);
    }
    get isExtrusionPull(): boolean {
        return this.get("isExtrusionPull") as boolean;
    }
    set isExtrusionPull(value: boolean) {
        this.set("isExtrusionPull", value);
    }
    get style(): string {
        return this.get("style") as string;
    }
    set style(value: string) {
        this.set("style", value);
    }
    get opacity(): number {
        return this.get("opacity") as number;
    }
    set opacity(value: number) {
        this.set("opacity", value);
    }
    get materials(): Material[] {
        return this.get("materials") as Material[];
    }
    set materials(value: Material[]) {
        this.set("materials", value);
    }
    get side(): "top" | "bottom" | "left" | "right" {
        return this.get("side") as "top" | "bottom" | "left" | "right";
    }
    set side(value: "top" | "bottom" | "left" | "right") {
        this.set("side", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Handle {
        const clone = new Handle(parent ?? this.parent);
        if(deep) {
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.width = this.width;
            clone.height = this.height;
            clone.assetId = this.assetId;
            clone.isExtrusionPull = this.isExtrusionPull;
            clone.style = this.style;
            clone.opacity = this.opacity;
            clone.materials = this.materials.map(
                item => item.clone(true, clone));
            clone.side = this.side;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Handle
    {
        const result = new Handle(parent);
        if(!data) {
            return result;
        }

        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.width = data["width"] ?? null;
        result.height = data["height"] ?? null;
        result.assetId = data["assetId"] ?? null;
        result.isExtrusionPull = data["isExtrusionPull"] ?? null;
        result.style = data["style"] ?? null;
        result.opacity = data["opacity"] ?? 1;
        result.materials = data["materials"]
            ? data["materials"].map(
                (item: any) => Material.fromJSON(item, result))
            : [];
        result.side = data["side"] ?? null;
        result.commit();
        return result;
    }

}

export class HookRack extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("width", null);
        this.fields.set("height", null);
        this.fields.set("depth", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("opacity", 1);
        this.fields.set("panel", Panel.fromJSON({}));
        this.fields.set("hook", null);
        this.fields.set("count", null);
        this.fields.set("layerId", null);
    }


    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get depth(): number {
        return this.get("depth") as number;
    }
    set depth(value: number) {
        this.set("depth", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get opacity(): number {
        return this.get("opacity") as number;
    }
    set opacity(value: number) {
        this.set("opacity", value);
    }
    get panel(): Panel {
        return this.get("panel") as Panel;
    }
    set panel(value: Panel) {
        this.set("panel", value);
    }
    get hook(): GenericAsset {
        return this.get("hook") as GenericAsset;
    }
    set hook(value: GenericAsset) {
        this.set("hook", value);
    }
    get count(): number {
        return this.get("count") as number;
    }
    set count(value: number) {
        this.set("count", value);
    }
    get layerId(): string {
        return this.get("layerId") as string;
    }
    set layerId(value: string) {
        this.set("layerId", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): HookRack {
        const clone = new HookRack(parent ?? this.parent);
        if(deep) {
            clone.width = this.width;
            clone.height = this.height;
            clone.depth = this.depth;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.opacity = this.opacity;
            clone.panel = this.panel?.clone(true, clone);
            clone.hook = this.hook?.clone(true, clone);
            clone.count = this.count;
            clone.layerId = this.layerId;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): HookRack
    {
        const result = new HookRack(parent);
        if(!data) {
            return result;
        }

        result.width = data["width"] ?? null;
        result.height = data["height"] ?? null;
        result.depth = data["depth"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.opacity = data["opacity"] ?? 1;
        result.panel = data["panel"]
            ? Panel.fromJSON(data["panel"], result)
            : Panel.fromJSON({});
        result.hook = data["hook"]
            ? GenericAsset.fromJSON(data["hook"], result)
            : null;
        result.count = data["count"] ?? null;
        result.layerId = data["layerId"] ?? null;
        result.commit();
        return result;
    }

}

export class Interval extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("start", null);
        this.fields.set("width", null);
    }


    get start(): number {
        return this.get("start") as number;
    }
    set start(value: number) {
        this.set("start", value);
    }
    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Interval {
        const clone = new Interval(parent ?? this.parent);
        if(deep) {
            clone.start = this.start;
            clone.width = this.width;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Interval
    {
        const result = new Interval(parent);
        if(!data) {
            return result;
        }

        result.start = data["start"] ?? null;
        result.width = data["width"] ?? null;
        result.commit();
        return result;
    }

}

export class Marker3D extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("id", null);
        this.fields.set("type", null);
        this.fields.set("label", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
    }


    get id(): string {
        return this.get("id") as string;
    }
    set id(value: string) {
        this.set("id", value);
    }
    get type(): "section" | "tech-drawing-label" {
        return this.get("type") as "section" | "tech-drawing-label";
    }
    set type(value: "section" | "tech-drawing-label") {
        this.set("type", value);
    }
    get label(): string {
        return this.get("label") as string;
    }
    set label(value: string) {
        this.set("label", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Marker3D {
        const clone = new Marker3D(parent ?? this.parent);
        if(deep) {
            clone.id = this.id;
            clone.type = this.type;
            clone.label = this.label;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Marker3D
    {
        const result = new Marker3D(parent);
        if(!data) {
            return result;
        }

        result.id = data["id"] ?? null;
        result.type = data["type"] ?? null;
        result.label = data["label"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.commit();
        return result;
    }

}

export class Material extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("assetId", null);
        this.fields.set("type", null);
        this.fields.set("color", null);
        this.fields.set("tint", null);
        this.fields.set("slot", null);
        this.fields.set("cubemap", null);
        this.fields.set("cubemapSuffix", null);
    }


    get assetId(): string {
        return this.get("assetId") as string;
    }
    set assetId(value: string) {
        this.set("assetId", value);
    }
    get type(): string {
        return this.get("type") as string;
    }
    set type(value: string) {
        this.set("type", value);
    }
    get color(): string {
        return this.get("color") as string;
    }
    set color(value: string) {
        this.set("color", value);
    }
    get tint(): string {
        return this.get("tint") as string;
    }
    set tint(value: string) {
        this.set("tint", value);
    }
    get slot(): string {
        return this.get("slot") as string;
    }
    set slot(value: string) {
        this.set("slot", value);
    }
    get cubemap(): string {
        return this.get("cubemap") as string;
    }
    set cubemap(value: string) {
        this.set("cubemap", value);
    }
    get cubemapSuffix(): string {
        return this.get("cubemapSuffix") as string;
    }
    set cubemapSuffix(value: string) {
        this.set("cubemapSuffix", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Material {
        const clone = new Material(parent ?? this.parent);
        if(deep) {
            clone.assetId = this.assetId;
            clone.type = this.type;
            clone.color = this.color;
            clone.tint = this.tint;
            clone.slot = this.slot;
            clone.cubemap = this.cubemap;
            clone.cubemapSuffix = this.cubemapSuffix;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Material
    {
        const result = new Material(parent);
        if(!data) {
            return result;
        }

        result.assetId = data["assetId"] ?? null;
        result.type = data["type"] ?? null;
        result.color = data["color"] ?? null;
        result.tint = data["tint"] ?? null;
        result.slot = data["slot"] ?? null;
        result.cubemap = data["cubemap"] ?? null;
        result.cubemapSuffix = data["cubemapSuffix"] ?? null;
        result.commit();
        return result;
    }

}

export class Molding extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("crown", null);
        this.fields.set("base", null);
    }


    get crown(): string {
        return this.get("crown") as string;
    }
    set crown(value: string) {
        this.set("crown", value);
    }
    get base(): string {
        return this.get("base") as string;
    }
    set base(value: string) {
        this.set("base", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Molding {
        const clone = new Molding(parent ?? this.parent);
        if(deep) {
            clone.crown = this.crown;
            clone.base = this.base;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Molding
    {
        const result = new Molding(parent);
        if(!data) {
            return result;
        }

        result.crown = data["crown"] ?? null;
        result.base = data["base"] ?? null;
        result.commit();
        return result;
    }

}

export class Murphybed extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("width", null);
        this.fields.set("height", null);
        this.fields.set("depth", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("size", null);
        this.fields.set("direction", null);
        this.fields.set("open", 0);
        this.fields.set("opacity", 1);
        this.fields.set("mattress", GenericAsset.fromJSON({}));
        this.fields.set("door", Door.fromJSON({}));
        this.fields.set("layerId", null);
    }


    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get depth(): number {
        return this.get("depth") as number;
    }
    set depth(value: number) {
        this.set("depth", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get size(): "queen" | "full" | "twin" {
        return this.get("size") as "queen" | "full" | "twin";
    }
    set size(value: "queen" | "full" | "twin") {
        this.set("size", value);
    }
    get direction(): "horizontal" | "vertical" {
        return this.get("direction") as "horizontal" | "vertical";
    }
    set direction(value: "horizontal" | "vertical") {
        this.set("direction", value);
    }
    get open(): number {
        return this.get("open") as number;
    }
    set open(value: number) {
        this.set("open", value);
    }
    get opacity(): number {
        return this.get("opacity") as number;
    }
    set opacity(value: number) {
        this.set("opacity", value);
    }
    get mattress(): GenericAsset {
        return this.get("mattress") as GenericAsset;
    }
    set mattress(value: GenericAsset) {
        this.set("mattress", value);
    }
    get door(): Door {
        return this.get("door") as Door;
    }
    set door(value: Door) {
        this.set("door", value);
    }
    get layerId(): string {
        return this.get("layerId") as string;
    }
    set layerId(value: string) {
        this.set("layerId", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Murphybed {
        const clone = new Murphybed(parent ?? this.parent);
        if(deep) {
            clone.width = this.width;
            clone.height = this.height;
            clone.depth = this.depth;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.size = this.size;
            clone.direction = this.direction;
            clone.open = this.open;
            clone.opacity = this.opacity;
            clone.mattress = this.mattress?.clone(true, clone);
            clone.door = this.door?.clone(true, clone);
            clone.layerId = this.layerId;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Murphybed
    {
        const result = new Murphybed(parent);
        if(!data) {
            return result;
        }

        result.width = data["width"] ?? null;
        result.height = data["height"] ?? null;
        result.depth = data["depth"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.size = data["size"] ?? null;
        result.direction = data["direction"] ?? null;
        result.open = data["open"] ?? 0;
        result.opacity = data["opacity"] ?? 1;
        result.mattress = data["mattress"]
            ? GenericAsset.fromJSON(data["mattress"], result)
            : GenericAsset.fromJSON({});
        result.door = data["door"]
            ? Door.fromJSON(data["door"], result)
            : Door.fromJSON({});
        result.layerId = data["layerId"] ?? null;
        result.commit();
        return result;
    }

}

export class Panel extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("style", null);
        this.fields.set("material", Material.fromJSON({}));
        this.fields.set("grain", null);
    }


    get style(): string {
        return this.get("style") as string;
    }
    set style(value: string) {
        this.set("style", value);
    }
    get material(): Material {
        return this.get("material") as Material;
    }
    set material(value: Material) {
        this.set("material", value);
    }
    get grain(): "horizontal" | "vertical" {
        return this.get("grain") as "horizontal" | "vertical";
    }
    set grain(value: "horizontal" | "vertical") {
        this.set("grain", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Panel {
        const clone = new Panel(parent ?? this.parent);
        if(deep) {
            clone.style = this.style;
            clone.material = this.material?.clone(true, clone);
            clone.grain = this.grain;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Panel
    {
        const result = new Panel(parent);
        if(!data) {
            return result;
        }

        result.style = data["style"] ?? null;
        result.material = data["material"]
            ? Material.fromJSON(data["material"], result)
            : Material.fromJSON({});
        result.grain = data["grain"] ?? null;
        result.commit();
        return result;
    }

}

export class ParametricPart extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("width", null);
        this.fields.set("height", null);
        this.fields.set("depth", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("opacity", 1);
        this.fields.set("materials", []);
        this.fields.set("name", null);
        this.fields.set("parameters", []);
        this.fields.set("layerId", null);
    }


    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get depth(): number {
        return this.get("depth") as number;
    }
    set depth(value: number) {
        this.set("depth", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get opacity(): number {
        return this.get("opacity") as number;
    }
    set opacity(value: number) {
        this.set("opacity", value);
    }
    get materials(): Material[] {
        return this.get("materials") as Material[];
    }
    set materials(value: Material[]) {
        this.set("materials", value);
    }
    get name(): string {
        return this.get("name") as string;
    }
    set name(value: string) {
        this.set("name", value);
    }
    get parameters(): Parameter[] {
        return this.get("parameters") as Parameter[];
    }
    set parameters(value: Parameter[]) {
        this.set("parameters", value);
    }
    get layerId(): string {
        return this.get("layerId") as string;
    }
    set layerId(value: string) {
        this.set("layerId", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): ParametricPart {
        const clone = new ParametricPart(parent ?? this.parent);
        if(deep) {
            clone.width = this.width;
            clone.height = this.height;
            clone.depth = this.depth;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.opacity = this.opacity;
            clone.materials = this.materials.map(
                item => item.clone(true, clone));
            clone.name = this.name;
            clone.parameters = this.parameters.map(
                item => item.clone(true, clone));
            clone.layerId = this.layerId;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): ParametricPart
    {
        const result = new ParametricPart(parent);
        if(!data) {
            return result;
        }

        result.width = data["width"] ?? null;
        result.height = data["height"] ?? null;
        result.depth = data["depth"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.opacity = data["opacity"] ?? 1;
        result.materials = data["materials"]
            ? data["materials"].map(
                (item: any) => Material.fromJSON(item, result))
            : [];
        result.name = data["name"] ?? null;
        result.parameters = data["parameters"]
            ? data["parameters"].map(
                (item: any) => Parameter.fromJSON(item, result))
            : [];
        result.layerId = data["layerId"] ?? null;
        result.commit();
        return result;
    }

}

export class Parameter extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("key", null);
        this.fields.set("value", null);
    }


    get key(): string {
        return this.get("key") as string;
    }
    set key(value: string) {
        this.set("key", value);
    }
    get value(): string {
        return this.get("value") as string;
    }
    set value(value: string) {
        this.set("value", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Parameter {
        const clone = new Parameter(parent ?? this.parent);
        if(deep) {
            clone.key = this.key;
            clone.value = this.value;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Parameter
    {
        const result = new Parameter(parent);
        if(!data) {
            return result;
        }

        result.key = data["key"] ?? null;
        result.value = data["value"] ?? null;
        result.commit();
        return result;
    }

}

export class Room extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("manufacturer", null);
        this.fields.set("line", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("primaryDoor", null);
        this.fields.set("walls", []);
        this.fields.set("floor", Material.fromJSON({}));
        this.fields.set("molding", Molding.fromJSON({}));
    }


    get manufacturer(): string {
        return this.get("manufacturer") as string;
    }
    set manufacturer(value: string) {
        this.set("manufacturer", value);
    }
    get line(): string {
        return this.get("line") as string;
    }
    set line(value: string) {
        this.set("line", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get primaryDoor(): DoorObstruction {
        return this.get("primaryDoor") as DoorObstruction;
    }
    set primaryDoor(value: DoorObstruction) {
        this.set("primaryDoor", value);
    }
    get walls(): Wall[] {
        return this.get("walls") as Wall[];
    }
    set walls(value: Wall[]) {
        this.set("walls", value);
    }
    get floor(): Material {
        return this.get("floor") as Material;
    }
    set floor(value: Material) {
        this.set("floor", value);
    }
    get molding(): Molding {
        return this.get("molding") as Molding;
    }
    set molding(value: Molding) {
        this.set("molding", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Room {
        const clone = new Room(parent ?? this.parent);
        if(deep) {
            clone.manufacturer = this.manufacturer;
            clone.line = this.line;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.primaryDoor = this.primaryDoor?.clone(true, clone);
            clone.walls = this.walls.map(
                item => item.clone(true, clone));
            clone.floor = this.floor?.clone(true, clone);
            clone.molding = this.molding?.clone(true, clone);
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Room
    {
        const result = new Room(parent);
        if(!data) {
            return result;
        }

        result.manufacturer = data["manufacturer"] ?? null;
        result.line = data["line"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.primaryDoor = data["primaryDoor"]
            ? DoorObstruction.fromJSON(data["primaryDoor"], result)
            : null;
        result.walls = data["walls"]
            ? data["walls"].map(
                (item: any) => Wall.fromJSON(item, result))
            : [];
        result.floor = data["floor"]
            ? Material.fromJSON(data["floor"], result)
            : Material.fromJSON({});
        result.molding = data["molding"]
            ? Molding.fromJSON(data["molding"], result)
            : Molding.fromJSON({});
        result.commit();
        return result;
    }

}

export class Section extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("width", null);
        this.fields.set("height", null);
        this.fields.set("depth", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("thickness", 0.75);
        this.fields.set("parametricParts", []);
        this.fields.set("assets", []);
        this.fields.set("drawers", []);
        this.fields.set("doors", []);
        this.fields.set("cubbies", []);
        this.fields.set("slantedShelves", []);
    }


    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get depth(): number {
        return this.get("depth") as number;
    }
    set depth(value: number) {
        this.set("depth", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get thickness(): 1 | 0.75 | 0.5 {
        return this.get("thickness") as 1 | 0.75 | 0.5;
    }
    set thickness(value: 1 | 0.75 | 0.5) {
        this.set("thickness", value);
    }
    get parametricParts(): ParametricPart[] {
        return this.get("parametricParts") as ParametricPart[];
    }
    set parametricParts(value: ParametricPart[]) {
        this.set("parametricParts", value);
    }
    get assets(): GenericAsset[] {
        return this.get("assets") as GenericAsset[];
    }
    set assets(value: GenericAsset[]) {
        this.set("assets", value);
    }
    get drawers(): Drawer[] {
        return this.get("drawers") as Drawer[];
    }
    set drawers(value: Drawer[]) {
        this.set("drawers", value);
    }
    get doors(): Door[] {
        return this.get("doors") as Door[];
    }
    set doors(value: Door[]) {
        this.set("doors", value);
    }
    get cubbies(): Cubby[] {
        return this.get("cubbies") as Cubby[];
    }
    set cubbies(value: Cubby[]) {
        this.set("cubbies", value);
    }
    get slantedShelves(): SlantedShelf[] {
        return this.get("slantedShelves") as SlantedShelf[];
    }
    set slantedShelves(value: SlantedShelf[]) {
        this.set("slantedShelves", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Section {
        const clone = new Section(parent ?? this.parent);
        if(deep) {
            clone.width = this.width;
            clone.height = this.height;
            clone.depth = this.depth;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.thickness = this.thickness;
            clone.parametricParts = this.parametricParts.map(
                item => item.clone(true, clone));
            clone.assets = this.assets.map(
                item => item.clone(true, clone));
            clone.drawers = this.drawers.map(
                item => item.clone(true, clone));
            clone.doors = this.doors.map(
                item => item.clone(true, clone));
            clone.cubbies = this.cubbies.map(
                item => item.clone(true, clone));
            clone.slantedShelves = this.slantedShelves.map(
                item => item.clone(true, clone));
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Section
    {
        const result = new Section(parent);
        if(!data) {
            return result;
        }

        result.width = data["width"] ?? null;
        result.height = data["height"] ?? null;
        result.depth = data["depth"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.thickness = data["thickness"] ?? 0.75;
        result.parametricParts = data["parametricParts"]
            ? data["parametricParts"].map(
                (item: any) => ParametricPart.fromJSON(item, result))
            : [];
        result.assets = data["assets"]
            ? data["assets"].map(
                (item: any) => GenericAsset.fromJSON(item, result))
            : [];
        result.drawers = data["drawers"]
            ? data["drawers"].map(
                (item: any) => Drawer.fromJSON(item, result))
            : [];
        result.doors = data["doors"]
            ? data["doors"].map(
                (item: any) => Door.fromJSON(item, result))
            : [];
        result.cubbies = data["cubbies"]
            ? data["cubbies"].map(
                (item: any) => Cubby.fromJSON(item, result))
            : [];
        result.slantedShelves = data["slantedShelves"]
            ? data["slantedShelves"].map(
                (item: any) => SlantedShelf.fromJSON(item, result))
            : [];
        result.commit();
        return result;
    }

}

export class SlantedShelf extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("width", null);
        this.fields.set("thickness", null);
        this.fields.set("depth", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("opacity", 1);
        this.fields.set("fenceAssetId", null);
        this.fields.set("shelfMaterials", []);
        this.fields.set("fenceMaterials", []);
        this.fields.set("layerId", null);
    }


    get width(): number {
        return this.get("width") as number;
    }
    set width(value: number) {
        this.set("width", value);
    }
    get thickness(): number {
        return this.get("thickness") as number;
    }
    set thickness(value: number) {
        this.set("thickness", value);
    }
    get depth(): number {
        return this.get("depth") as number;
    }
    set depth(value: number) {
        this.set("depth", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get opacity(): number {
        return this.get("opacity") as number;
    }
    set opacity(value: number) {
        this.set("opacity", value);
    }
    get fenceAssetId(): string {
        return this.get("fenceAssetId") as string;
    }
    set fenceAssetId(value: string) {
        this.set("fenceAssetId", value);
    }
    get shelfMaterials(): Material[] {
        return this.get("shelfMaterials") as Material[];
    }
    set shelfMaterials(value: Material[]) {
        this.set("shelfMaterials", value);
    }
    get fenceMaterials(): Material[] {
        return this.get("fenceMaterials") as Material[];
    }
    set fenceMaterials(value: Material[]) {
        this.set("fenceMaterials", value);
    }
    get layerId(): string {
        return this.get("layerId") as string;
    }
    set layerId(value: string) {
        this.set("layerId", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): SlantedShelf {
        const clone = new SlantedShelf(parent ?? this.parent);
        if(deep) {
            clone.width = this.width;
            clone.thickness = this.thickness;
            clone.depth = this.depth;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.opacity = this.opacity;
            clone.fenceAssetId = this.fenceAssetId;
            clone.shelfMaterials = this.shelfMaterials.map(
                item => item.clone(true, clone));
            clone.fenceMaterials = this.fenceMaterials.map(
                item => item.clone(true, clone));
            clone.layerId = this.layerId;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): SlantedShelf
    {
        const result = new SlantedShelf(parent);
        if(!data) {
            return result;
        }

        result.width = data["width"] ?? null;
        result.thickness = data["thickness"] ?? null;
        result.depth = data["depth"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.opacity = data["opacity"] ?? 1;
        result.fenceAssetId = data["fenceAssetId"] ?? null;
        result.shelfMaterials = data["shelfMaterials"]
            ? data["shelfMaterials"].map(
                (item: any) => Material.fromJSON(item, result))
            : [];
        result.fenceMaterials = data["fenceMaterials"]
            ? data["fenceMaterials"].map(
                (item: any) => Material.fromJSON(item, result))
            : [];
        result.layerId = data["layerId"] ?? null;
        result.commit();
        return result;
    }

}

export class VerticalPanel extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("thickness", 0.75);
        this.fields.set("height", null);
        this.fields.set("depth", null);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("showLeftFaceHoles", false);
        this.fields.set("showRightFaceHoles", false);
        this.fields.set("hutch", false);
        this.fields.set("hutchDepth", null);
        this.fields.set("hutchHeight", null);
        this.fields.set("hutchInnerRadius", 0);
        this.fields.set("hutchOuterRadius", 0);
        this.fields.set("topFrontCutbackDepth", 0);
        this.fields.set("topFrontCutbackHeight", 0);
        this.fields.set("bottomFrontRadius", 0);
        this.fields.set("opacity", 1);
        this.fields.set("materials", []);
        this.fields.set("layerId", null);
    }


    get thickness(): number {
        return this.get("thickness") as number;
    }
    set thickness(value: number) {
        this.set("thickness", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }
    get depth(): number {
        return this.get("depth") as number;
    }
    set depth(value: number) {
        this.set("depth", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get showLeftFaceHoles(): boolean {
        return this.get("showLeftFaceHoles") as boolean;
    }
    set showLeftFaceHoles(value: boolean) {
        this.set("showLeftFaceHoles", value);
    }
    get showRightFaceHoles(): boolean {
        return this.get("showRightFaceHoles") as boolean;
    }
    set showRightFaceHoles(value: boolean) {
        this.set("showRightFaceHoles", value);
    }
    get hutch(): boolean {
        return this.get("hutch") as boolean;
    }
    set hutch(value: boolean) {
        this.set("hutch", value);
    }
    get hutchDepth(): number {
        return this.get("hutchDepth") as number;
    }
    set hutchDepth(value: number) {
        this.set("hutchDepth", value);
    }
    get hutchHeight(): number {
        return this.get("hutchHeight") as number;
    }
    set hutchHeight(value: number) {
        this.set("hutchHeight", value);
    }
    get hutchInnerRadius(): number {
        return this.get("hutchInnerRadius") as number;
    }
    set hutchInnerRadius(value: number) {
        this.set("hutchInnerRadius", value);
    }
    get hutchOuterRadius(): number {
        return this.get("hutchOuterRadius") as number;
    }
    set hutchOuterRadius(value: number) {
        this.set("hutchOuterRadius", value);
    }
    get topFrontCutbackDepth(): number {
        return this.get("topFrontCutbackDepth") as number;
    }
    set topFrontCutbackDepth(value: number) {
        this.set("topFrontCutbackDepth", value);
    }
    get topFrontCutbackHeight(): number {
        return this.get("topFrontCutbackHeight") as number;
    }
    set topFrontCutbackHeight(value: number) {
        this.set("topFrontCutbackHeight", value);
    }
    get bottomFrontRadius(): number {
        return this.get("bottomFrontRadius") as number;
    }
    set bottomFrontRadius(value: number) {
        this.set("bottomFrontRadius", value);
    }
    get opacity(): number {
        return this.get("opacity") as number;
    }
    set opacity(value: number) {
        this.set("opacity", value);
    }
    get materials(): Material[] {
        return this.get("materials") as Material[];
    }
    set materials(value: Material[]) {
        this.set("materials", value);
    }
    get layerId(): string {
        return this.get("layerId") as string;
    }
    set layerId(value: string) {
        this.set("layerId", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): VerticalPanel {
        const clone = new VerticalPanel(parent ?? this.parent);
        if(deep) {
            clone.thickness = this.thickness;
            clone.height = this.height;
            clone.depth = this.depth;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.showLeftFaceHoles = this.showLeftFaceHoles;
            clone.showRightFaceHoles = this.showRightFaceHoles;
            clone.hutch = this.hutch;
            clone.hutchDepth = this.hutchDepth;
            clone.hutchHeight = this.hutchHeight;
            clone.hutchInnerRadius = this.hutchInnerRadius;
            clone.hutchOuterRadius = this.hutchOuterRadius;
            clone.topFrontCutbackDepth = this.topFrontCutbackDepth;
            clone.topFrontCutbackHeight = this.topFrontCutbackHeight;
            clone.bottomFrontRadius = this.bottomFrontRadius;
            clone.opacity = this.opacity;
            clone.materials = this.materials.map(
                item => item.clone(true, clone));
            clone.layerId = this.layerId;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): VerticalPanel
    {
        const result = new VerticalPanel(parent);
        if(!data) {
            return result;
        }

        result.thickness = data["thickness"] ?? 0.75;
        result.height = data["height"] ?? null;
        result.depth = data["depth"] ?? null;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.showLeftFaceHoles = data["showLeftFaceHoles"] ?? false;
        result.showRightFaceHoles = data["showRightFaceHoles"] ?? false;
        result.hutch = data["hutch"] ?? false;
        result.hutchDepth = data["hutchDepth"] ?? null;
        result.hutchHeight = data["hutchHeight"] ?? null;
        result.hutchInnerRadius = data["hutchInnerRadius"] ?? 0;
        result.hutchOuterRadius = data["hutchOuterRadius"] ?? 0;
        result.topFrontCutbackDepth = data["topFrontCutbackDepth"] ?? 0;
        result.topFrontCutbackHeight = data["topFrontCutbackHeight"] ?? 0;
        result.bottomFrontRadius = data["bottomFrontRadius"] ?? 0;
        result.opacity = data["opacity"] ?? 1;
        result.materials = data["materials"]
            ? data["materials"].map(
                (item: any) => Material.fromJSON(item, result))
            : [];
        result.layerId = data["layerId"] ?? null;
        result.commit();
        return result;
    }

}

export class Wall extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("wallId", null);
        this.fields.set("wallOrder", 0);
        this.fields.set("parentWallOrder", 0);
        this.fields.set("position", Vector3.fromJSON({}));
        this.fields.set("rotation", Vector3.fromJSON({}));
        this.fields.set("scale", Vector3.fromJSON({"x":1,"y":1,"z":1}));
        this.fields.set("heights", []);
        this.fields.set("nominalLength", null);
        this.fields.set("depth", null);
        this.fields.set("visible", true);
        this.fields.set("island", null);
        this.fields.set("islandClearance", 24);
        this.fields.set("showOpenSpace", null);
        this.fields.set("showOpenSpaceIndex", null);
        this.fields.set("leftExtension", 0);
        this.fields.set("rightExtension", 0);
        this.fields.set("showExtension", false);
        this.fields.set("prefill", "none");
        this.fields.set("thickness", 0.75);
        this.fields.set("material", Material.fromJSON({}));
        this.fields.set("panels", []);
        this.fields.set("doors", []);
        this.fields.set("drawers", []);
        this.fields.set("assets", []);
        this.fields.set("beds", []);
        this.fields.set("parametricParts", []);
        this.fields.set("hookRacks", []);
        this.fields.set("cubbies", []);
        this.fields.set("sections", []);
        this.fields.set("closetUnits", []);
        this.fields.set("openSpaces", []);
        this.fields.set("markers", []);
        this.fields.set("slantedShelves", []);
    }


    get wallId(): string {
        return this.get("wallId") as string;
    }
    set wallId(value: string) {
        this.set("wallId", value);
    }
    get wallOrder(): number {
        return this.get("wallOrder") as number;
    }
    set wallOrder(value: number) {
        this.set("wallOrder", value);
    }
    get parentWallOrder(): number {
        return this.get("parentWallOrder") as number;
    }
    set parentWallOrder(value: number) {
        this.set("parentWallOrder", value);
    }
    get position(): Vector3 {
        return this.get("position") as Vector3;
    }
    set position(value: Vector3) {
        this.set("position", value);
    }
    get rotation(): Vector3 {
        return this.get("rotation") as Vector3;
    }
    set rotation(value: Vector3) {
        this.set("rotation", value);
    }
    get scale(): Vector3 {
        return this.get("scale") as Vector3;
    }
    set scale(value: Vector3) {
        this.set("scale", value);
    }
    get heights(): WallHeight[] {
        return this.get("heights") as WallHeight[];
    }
    set heights(value: WallHeight[]) {
        this.set("heights", value);
    }
    get nominalLength(): number {
        return this.get("nominalLength") as number;
    }
    set nominalLength(value: number) {
        this.set("nominalLength", value);
    }
    get depth(): number {
        return this.get("depth") as number;
    }
    set depth(value: number) {
        this.set("depth", value);
    }
    get visible(): boolean {
        return this.get("visible") as boolean;
    }
    set visible(value: boolean) {
        this.set("visible", value);
    }
    get island(): boolean {
        return this.get("island") as boolean;
    }
    set island(value: boolean) {
        this.set("island", value);
    }
    get islandClearance(): number {
        return this.get("islandClearance") as number;
    }
    set islandClearance(value: number) {
        this.set("islandClearance", value);
    }
    get showOpenSpace(): boolean {
        return this.get("showOpenSpace") as boolean;
    }
    set showOpenSpace(value: boolean) {
        this.set("showOpenSpace", value);
    }
    get showOpenSpaceIndex(): number {
        return this.get("showOpenSpaceIndex") as number;
    }
    set showOpenSpaceIndex(value: number) {
        this.set("showOpenSpaceIndex", value);
    }
    get leftExtension(): number {
        return this.get("leftExtension") as number;
    }
    set leftExtension(value: number) {
        this.set("leftExtension", value);
    }
    get rightExtension(): number {
        return this.get("rightExtension") as number;
    }
    set rightExtension(value: number) {
        this.set("rightExtension", value);
    }
    get showExtension(): boolean {
        return this.get("showExtension") as boolean;
    }
    set showExtension(value: boolean) {
        this.set("showExtension", value);
    }
    get prefill(): "all" | "fill" | "fill-start" | "fill-end" | "fill-both" | "none" {
        return this.get("prefill") as "all" | "fill" | "fill-start" | "fill-end" | "fill-both" | "none";
    }
    set prefill(value: "all" | "fill" | "fill-start" | "fill-end" | "fill-both" | "none") {
        this.set("prefill", value);
    }
    get thickness(): 1 | 0.75 | 0.5 {
        return this.get("thickness") as 1 | 0.75 | 0.5;
    }
    set thickness(value: 1 | 0.75 | 0.5) {
        this.set("thickness", value);
    }
    get material(): Material {
        return this.get("material") as Material;
    }
    set material(value: Material) {
        this.set("material", value);
    }
    get panels(): VerticalPanel[] {
        return this.get("panels") as VerticalPanel[];
    }
    set panels(value: VerticalPanel[]) {
        this.set("panels", value);
    }
    get doors(): Door[] {
        return this.get("doors") as Door[];
    }
    set doors(value: Door[]) {
        this.set("doors", value);
    }
    get drawers(): Drawer[] {
        return this.get("drawers") as Drawer[];
    }
    set drawers(value: Drawer[]) {
        this.set("drawers", value);
    }
    get assets(): GenericAsset[] {
        return this.get("assets") as GenericAsset[];
    }
    set assets(value: GenericAsset[]) {
        this.set("assets", value);
    }
    get beds(): Murphybed[] {
        return this.get("beds") as Murphybed[];
    }
    set beds(value: Murphybed[]) {
        this.set("beds", value);
    }
    get parametricParts(): ParametricPart[] {
        return this.get("parametricParts") as ParametricPart[];
    }
    set parametricParts(value: ParametricPart[]) {
        this.set("parametricParts", value);
    }
    get hookRacks(): HookRack[] {
        return this.get("hookRacks") as HookRack[];
    }
    set hookRacks(value: HookRack[]) {
        this.set("hookRacks", value);
    }
    get cubbies(): Cubby[] {
        return this.get("cubbies") as Cubby[];
    }
    set cubbies(value: Cubby[]) {
        this.set("cubbies", value);
    }
    get sections(): Section[] {
        return this.get("sections") as Section[];
    }
    set sections(value: Section[]) {
        this.set("sections", value);
    }
    get closetUnits(): ClosetUnit[] {
        return this.get("closetUnits") as ClosetUnit[];
    }
    set closetUnits(value: ClosetUnit[]) {
        this.set("closetUnits", value);
    }
    get openSpaces(): Interval[] {
        return this.get("openSpaces") as Interval[];
    }
    set openSpaces(value: Interval[]) {
        this.set("openSpaces", value);
    }
    get markers(): Marker3D[] {
        return this.get("markers") as Marker3D[];
    }
    set markers(value: Marker3D[]) {
        this.set("markers", value);
    }
    get slantedShelves(): SlantedShelf[] {
        return this.get("slantedShelves") as SlantedShelf[];
    }
    set slantedShelves(value: SlantedShelf[]) {
        this.set("slantedShelves", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): Wall {
        const clone = new Wall(parent ?? this.parent);
        if(deep) {
            clone.wallId = this.wallId;
            clone.wallOrder = this.wallOrder;
            clone.parentWallOrder = this.parentWallOrder;
            clone.position = this.position?.clone(true, clone);
            clone.rotation = this.rotation?.clone(true, clone);
            clone.scale = this.scale?.clone(true, clone);
            clone.heights = this.heights.map(
                item => item.clone(true, clone));
            clone.nominalLength = this.nominalLength;
            clone.depth = this.depth;
            clone.visible = this.visible;
            clone.island = this.island;
            clone.islandClearance = this.islandClearance;
            clone.showOpenSpace = this.showOpenSpace;
            clone.showOpenSpaceIndex = this.showOpenSpaceIndex;
            clone.leftExtension = this.leftExtension;
            clone.rightExtension = this.rightExtension;
            clone.showExtension = this.showExtension;
            clone.prefill = this.prefill;
            clone.thickness = this.thickness;
            clone.material = this.material?.clone(true, clone);
            clone.panels = this.panels.map(
                item => item.clone(true, clone));
            clone.doors = this.doors.map(
                item => item.clone(true, clone));
            clone.drawers = this.drawers.map(
                item => item.clone(true, clone));
            clone.assets = this.assets.map(
                item => item.clone(true, clone));
            clone.beds = this.beds.map(
                item => item.clone(true, clone));
            clone.parametricParts = this.parametricParts.map(
                item => item.clone(true, clone));
            clone.hookRacks = this.hookRacks.map(
                item => item.clone(true, clone));
            clone.cubbies = this.cubbies.map(
                item => item.clone(true, clone));
            clone.sections = this.sections.map(
                item => item.clone(true, clone));
            clone.closetUnits = this.closetUnits.map(
                item => item.clone(true, clone));
            clone.openSpaces = this.openSpaces.map(
                item => item.clone(true, clone));
            clone.markers = this.markers.map(
                item => item.clone(true, clone));
            clone.slantedShelves = this.slantedShelves.map(
                item => item.clone(true, clone));
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): Wall
    {
        const result = new Wall(parent);
        if(!data) {
            return result;
        }

        result.wallId = data["wallId"] ?? null;
        result.wallOrder = data["wallOrder"] ?? 0;
        result.parentWallOrder = data["parentWallOrder"] ?? 0;
        result.position = data["position"]
            ? Vector3.fromJSON(data["position"], result)
            : Vector3.fromJSON({});
        result.rotation = data["rotation"]
            ? Vector3.fromJSON(data["rotation"], result)
            : Vector3.fromJSON({});
        result.scale = data["scale"]
            ? Vector3.fromJSON(data["scale"], result)
            : Vector3.fromJSON({"x":1,"y":1,"z":1});
        result.heights = data["heights"]
            ? data["heights"].map(
                (item: any) => WallHeight.fromJSON(item, result))
            : [];
        result.nominalLength = data["nominalLength"] ?? null;
        result.depth = data["depth"] ?? null;
        result.visible = data["visible"] ?? true;
        result.island = data["island"] ?? null;
        result.islandClearance = data["islandClearance"] ?? 24;
        result.showOpenSpace = data["showOpenSpace"] ?? null;
        result.showOpenSpaceIndex = data["showOpenSpaceIndex"] ?? null;
        result.leftExtension = data["leftExtension"] ?? 0;
        result.rightExtension = data["rightExtension"] ?? 0;
        result.showExtension = data["showExtension"] ?? false;
        result.prefill = data["prefill"] ?? "none";
        result.thickness = data["thickness"] ?? 0.75;
        result.material = data["material"]
            ? Material.fromJSON(data["material"], result)
            : Material.fromJSON({});
        result.panels = data["panels"]
            ? data["panels"].map(
                (item: any) => VerticalPanel.fromJSON(item, result))
            : [];
        result.doors = data["doors"]
            ? data["doors"].map(
                (item: any) => Door.fromJSON(item, result))
            : [];
        result.drawers = data["drawers"]
            ? data["drawers"].map(
                (item: any) => Drawer.fromJSON(item, result))
            : [];
        result.assets = data["assets"]
            ? data["assets"].map(
                (item: any) => GenericAsset.fromJSON(item, result))
            : [];
        result.beds = data["beds"]
            ? data["beds"].map(
                (item: any) => Murphybed.fromJSON(item, result))
            : [];
        result.parametricParts = data["parametricParts"]
            ? data["parametricParts"].map(
                (item: any) => ParametricPart.fromJSON(item, result))
            : [];
        result.hookRacks = data["hookRacks"]
            ? data["hookRacks"].map(
                (item: any) => HookRack.fromJSON(item, result))
            : [];
        result.cubbies = data["cubbies"]
            ? data["cubbies"].map(
                (item: any) => Cubby.fromJSON(item, result))
            : [];
        result.sections = data["sections"]
            ? data["sections"].map(
                (item: any) => Section.fromJSON(item, result))
            : [];
        result.closetUnits = data["closetUnits"]
            ? data["closetUnits"].map(
                (item: any) => ClosetUnit.fromJSON(item, result))
            : [];
        result.openSpaces = data["openSpaces"]
            ? data["openSpaces"].map(
                (item: any) => Interval.fromJSON(item, result))
            : [];
        result.markers = data["markers"]
            ? data["markers"].map(
                (item: any) => Marker3D.fromJSON(item, result))
            : [];
        result.slantedShelves = data["slantedShelves"]
            ? data["slantedShelves"].map(
                (item: any) => SlantedShelf.fromJSON(item, result))
            : [];
        result.commit();
        return result;
    }

}

export class WallHeight extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("x", null);
        this.fields.set("height", null);
    }


    get x(): number {
        return this.get("x") as number;
    }
    set x(value: number) {
        this.set("x", value);
    }
    get height(): number {
        return this.get("height") as number;
    }
    set height(value: number) {
        this.set("height", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): WallHeight {
        const clone = new WallHeight(parent ?? this.parent);
        if(deep) {
            clone.x = this.x;
            clone.height = this.height;
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): WallHeight
    {
        const result = new WallHeight(parent);
        if(!data) {
            return result;
        }

        result.x = data["x"] ?? null;
        result.height = data["height"] ?? null;
        result.commit();
        return result;
    }

}

export class UnitEditorAssetItem extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("label", null);
        this.fields.set("cubby", null);
        this.fields.set("door", null);
        this.fields.set("drawer", null);
        this.fields.set("genericAsset", null);
        this.fields.set("parametricPart", null);
        this.fields.set("slantedShelf", null);
    }


    get label(): string {
        return this.get("label") as string;
    }
    set label(value: string) {
        this.set("label", value);
    }
    get cubby(): Cubby {
        return this.get("cubby") as Cubby;
    }
    set cubby(value: Cubby) {
        this.set("cubby", value);
    }
    get door(): Door {
        return this.get("door") as Door;
    }
    set door(value: Door) {
        this.set("door", value);
    }
    get drawer(): Drawer {
        return this.get("drawer") as Drawer;
    }
    set drawer(value: Drawer) {
        this.set("drawer", value);
    }
    get genericAsset(): GenericAsset {
        return this.get("genericAsset") as GenericAsset;
    }
    set genericAsset(value: GenericAsset) {
        this.set("genericAsset", value);
    }
    get parametricPart(): ParametricPart {
        return this.get("parametricPart") as ParametricPart;
    }
    set parametricPart(value: ParametricPart) {
        this.set("parametricPart", value);
    }
    get slantedShelf(): SlantedShelf {
        return this.get("slantedShelf") as SlantedShelf;
    }
    set slantedShelf(value: SlantedShelf) {
        this.set("slantedShelf", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): UnitEditorAssetItem {
        const clone = new UnitEditorAssetItem(parent ?? this.parent);
        if(deep) {
            clone.label = this.label;
            clone.cubby = this.cubby?.clone(true, clone);
            clone.door = this.door?.clone(true, clone);
            clone.drawer = this.drawer?.clone(true, clone);
            clone.genericAsset = this.genericAsset?.clone(true, clone);
            clone.parametricPart = this.parametricPart?.clone(true, clone);
            clone.slantedShelf = this.slantedShelf?.clone(true, clone);
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): UnitEditorAssetItem
    {
        const result = new UnitEditorAssetItem(parent);
        if(!data) {
            return result;
        }

        result.label = data["label"] ?? null;
        result.cubby = data["cubby"]
            ? Cubby.fromJSON(data["cubby"], result)
            : null;
        result.door = data["door"]
            ? Door.fromJSON(data["door"], result)
            : null;
        result.drawer = data["drawer"]
            ? Drawer.fromJSON(data["drawer"], result)
            : null;
        result.genericAsset = data["genericAsset"]
            ? GenericAsset.fromJSON(data["genericAsset"], result)
            : null;
        result.parametricPart = data["parametricPart"]
            ? ParametricPart.fromJSON(data["parametricPart"], result)
            : null;
        result.slantedShelf = data["slantedShelf"]
            ? SlantedShelf.fromJSON(data["slantedShelf"], result)
            : null;
        result.commit();
        return result;
    }

}

export class UnitEditorAssetBin extends DomainModel {

    constructor(parent?: DomainModel) {
        super(parent);

        this.fields = new Map();
        this.fields.set("label", null);
        this.fields.set("order", null);
        this.fields.set("items", []);
    }


    get label(): string {
        return this.get("label") as string;
    }
    set label(value: string) {
        this.set("label", value);
    }
    get order(): number {
        return this.get("order") as number;
    }
    set order(value: number) {
        this.set("order", value);
    }
    get items(): UnitEditorAssetItem[] {
        return this.get("items") as UnitEditorAssetItem[];
    }
    set items(value: UnitEditorAssetItem[]) {
        this.set("items", value);
    }


    clone(deep: boolean = false, parent: DomainModel = null): UnitEditorAssetBin {
        const clone = new UnitEditorAssetBin(parent ?? this.parent);
        if(deep) {
            clone.label = this.label;
            clone.order = this.order;
            clone.items = this.items.map(
                item => item.clone(true, clone));
        } else {
            for(let [field, value] of this.fields) {
                clone.set(field, value);
            }
        }
        clone.commit();
        return clone;
    }


    static fromJSON(data: unknown, parent?: DomainModel): UnitEditorAssetBin
    {
        const result = new UnitEditorAssetBin(parent);
        if(!data) {
            return result;
        }

        result.label = data["label"] ?? null;
        result.order = data["order"] ?? null;
        result.items = data["items"]
            ? data["items"].map(
                (item: any) => UnitEditorAssetItem.fromJSON(item, result))
            : [];
        result.commit();
        return result;
    }

}
